// ai-sidebar/components/orb.tsx
// The single AI mark, reused everywhere at the design's exact sizes (40px
// header, 26px message avatar, 38px collapsed launcher). Always breathes
// (violet glow); a halo ring is layered on only while the assistant works.
import { Sparkles } from "lucide-react";

export const ORB_GRADIENT =
  "linear-gradient(135deg,var(--spectral-violet) 0%,var(--spectral-violet) 62%,var(--signal-blue) 155%)";

interface OrbProps {
  size?: number;
  /** Add the halo pulse ring (only while the assistant is working). */
  working?: boolean;
  className?: string;
}

export function Orb({ size = 40, working = false, className = "" }: OrbProps) {
  const radius = size >= 40 ? 12 : 8;
  const icon = size >= 40 ? 18 : 14;
  return (
    <span
      className={`ai-orb relative inline-flex items-center justify-center shrink-0 ${className}`}
      style={{ width: size, height: size, borderRadius: radius, background: ORB_GRADIENT }}
      aria-hidden="true"
    >
      <Sparkles style={{ width: icon, height: icon, color: "#fff", strokeWidth: 1.85 }} />
      {working && <span className="ai-orb-halo-ring" />}
    </span>
  );
}
